export const getArtistTag = (artist?: ArtistPageContent) => {
  return artist
    ? artist.content &&
      artist.content.shopifyTag &&
      artist.content.shopifyTag.length > 0
      ? artist.content.shopifyTag
      : artist.name
    : '';
};
